import { useState, useEffect } from 'react';

const useResponsive = () => {

  const [viewport, setViewport] = useState({});

  useEffect(() => {
    const handleResize = () => {
      const { innerWidth } = window;

      const xs = innerWidth <= 767;
      const sm = innerWidth > 767 && innerWidth <= 1023;
      const cm = innerWidth > 1023 && innerWidth <= 1199;
      const md = innerWidth >= 1024;
      const lg = innerWidth >= 1200;
      const xl = innerWidth >= 1600;

      setViewport({ xs, sm, cm, md, lg, xl });
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return viewport;
};

export default useResponsive;
